module.exports = __webpack_public_path__ + "media/images/slider003-80f38ceedfa968d62525bf884cde62f6.jpg";